import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search as SearchIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo } from "react";
import { useSelector } from "react-redux";
import { TopBar } from "~/_components/TopBar";
import { PublicBoardFiltersButton } from "~/components/Filters/FiltersButton/PublicBoardFiltersButton";
import { PublicSearch } from "~/components/Search/PublicSearch";
import { SearchRow } from "~/components/Shared/HeaderBar/SearchRow";
import { useMobileSearchBar } from "~/hooks/search/useMobileSearchBar";
import { usePublicHeaderHorizontalPadding } from "~/hooks/usePublicHeaderHorizontalPadding";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { centralizedBoardSelector } from "~/store/centralizedBoard/selectors";
import { PublicBoardHeaderActions } from "./PublicBoardHeaderActions";
export const PublicHeaderBar = /*#__PURE__*/ memo((param)=>{
    let { headerRef } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const { openMobileSearch, isMobileSearchOpen, closeMobileSearch } = useMobileSearchBar();
    const { responsiveHorizontalPadding } = usePublicHeaderHorizontalPadding();
    const board = useSelector(centralizedBoardSelector);
    const { searchImprovements } = useTemporaryFeatureFlags();
    var _board_id;
    return /*#__PURE__*/ _jsx(TopBar, {
        className: "bg-grey-1 pb-0 md:pb-0",
        ref: headerRef,
        style: {
            paddingLeft: responsiveHorizontalPadding,
            paddingRight: responsiveHorizontalPadding,
            zIndex: isMobileSearchOpen ? 6 : 5
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex w-full justify-between gap-6 pb-2 md:pb-3",
            children: [
                /*#__PURE__*/ _jsx(SearchRow, {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex grow justify-end md:justify-start",
                        children: [
                            isAboveMediumScreen || isMobileSearchOpen ? /*#__PURE__*/ _jsx(PublicSearch, {
                                onCloseClick: closeMobileSearch
                            }) : /*#__PURE__*/ _jsx(IconButton, {
                                appearance: "ghost",
                                color: "grey",
                                size: "large",
                                icon: SearchIcon,
                                onClick: openMobileSearch,
                                label: "Search"
                            }),
                            (!searchImprovements || !isAboveMediumScreen) && /*#__PURE__*/ _jsx("div", {
                                className: "ml-2",
                                children: /*#__PURE__*/ _jsx(PublicBoardFiltersButton, {
                                    boardId: (_board_id = board === null || board === void 0 ? void 0 : board.id) !== null && _board_id !== void 0 ? _board_id : ""
                                })
                            })
                        ]
                    })
                }),
                !!board && /*#__PURE__*/ _jsx(PublicBoardHeaderActions, {
                    board: board
                })
            ]
        })
    });
});
PublicHeaderBar.displayName = "PublicHeaderBar";
